var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"items-per-page":5,"item-key":"tkt_id","height":"350px"},scopedSlots:_vm._u([{key:"item.tkt_date_entered",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatDate(item.tkt_date_entered))+" ")]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }